import React from "react";
import "./Calculator.css";
import Login from "../login/Login.js";
import "./app.css";

class Calculator extends React.Component {
  // Placeholer element
  render() {
    return (
      <div>
        <div>
          <div id="search bar here">
            <Login></Login>
          </div>
        </div>
      </div>
    );
  }
}

export default Calculator;
